import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { Store } from '@ngxs/store';
import { catchError, first, of, tap } from 'rxjs';
import { KeycloakGnService } from '../../../../shared/services/keycloak-gn.service';
import { MainActions } from '../state/main.actions';

export const firstAccessibleRoute = (keycloakGnService: KeycloakGnService): string => {
  const userRoles = keycloakGnService.instance.realmAccess?.roles || [];
  if (userRoles.includes('CHAT_CONVERSATIONS')) {
    return 'botting';
  }
  if (userRoles.includes('LYA_LIVE')) {
    return 'meetings';
  }
  if (userRoles.includes('LYA_AUTO')) {
    return 'lya';
  }
  if (userRoles.includes('1GCV')) {
    return 'cv1g';
  }
  if (userRoles.includes('LYA_CANDIDATES')) {
    return 'candidates';
  }
  if (userRoles.includes('1G-admin')) {
    return 'admin-console';
  }
  return 'botting';
};

export const userCompanyInfoResolver: ResolveFn<any> = () => {
  const store = inject(Store);
  const keycloakGnService = inject(KeycloakGnService);
  return keycloakGnService.myCompany().pipe(
    first(),
    catchError(() => of('')),
    tap((company) => store.dispatch(new MainActions.getUserCompany(company))),
  );
};
